module.exports = __webpack_public_path__ + "img/tzxj.fd87e917.jpg";